module.exports = __webpack_public_path__ + "img/6-box.34c765fb.png";